import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DeliveryTypeTimeResponse} from 'src/app/data/networking/models/delivery-type-time/delivery-type-time.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveryTypeTimeEvent {
  deliveryTypeTimeInitialstate: DeliveryTypeTimeResponse = {
    deliveryTimes: [
      {
        type: 'envialoya',
        description: 'de 8 a 12 días en promedio el último mes',
        estimatedTime: '8 - 12 días',
      },
      {
        type: 'national',
        description: 'de 5 días en promedio el último mes',
        estimatedTime: '5 días',
      },
      {
        type: 'express',
        description: 'En 35 mins promedio',
        estimatedTime: '35 mins',
      },
      {
        type: 'provider',
        description: 'De 4 a 5 dias hábiles',
        estimatedTime: '4-5 días',
      },
    ],
  };
  private deliveryTypeTime = new BehaviorSubject(this.deliveryTypeTimeInitialstate);
  get = this.deliveryTypeTime.asObservable();

  update(event: DeliveryTypeTimeResponse): void {
    this.deliveryTypeTime.next(event);
  }
}
